(() => {
  'use strict';

  const dialog = document.querySelector('[data-card-enquire-dialog]');
  if (!dialog) return;

  const form = dialog.querySelector('[data-rk-lead-form]');
  const title = dialog.querySelector('[data-card-enquire-title]');
  const closeButton = dialog.querySelector('[data-card-enquire-close]');

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-card-enquire-open]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    const productTitle = trigger.dataset.productTitle || '';
    title.textContent = productTitle;
    form.elements.namedItem('sku').value = trigger.dataset.productSku || '';
    form.elements.namedItem('product').value = productTitle;
    form.elements.namedItem('product_url').value = trigger.dataset.productUrl || '';
    dialog.showModal();
  });

  closeButton?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
})();
